import {hetch} from "./fetch.hooked";

const REGEXP = /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/;
 
const extractFileName = (contentDisposition) => {
    const match = contentDisposition.match(REGEXP);
    return match?.[1] ?? null;
};

const download = async (url) => {
  const response = await hetch(url);
  const contentDisposition = response.headers.get('Content-Disposition');
  const fileName = contentDisposition ? extractFileName(contentDisposition) ?? 'id.cer' : 'id.cer';
  const blob = await response.blob();
  return new File([blob], fileName);
};

export const openDownloadWindow = (url) => {
  download(url).then(file => {
    const url = window.URL.createObjectURL(file);
    const anchorElement = document.createElement('a');
    anchorElement.href = url;
    anchorElement.download = file.name;
    document.body.appendChild(anchorElement);
    anchorElement.click();
    anchorElement.remove();
  })
};
